export const ADVENTURE_ISLAND_ID = 'adventure-island';

export const TILE_SIZE = 16;

/** Walking speed in pixels per second (4.5 tiles per second). */
export const PLAYER_SPEED = 72;

/** Collision box at the player's feet. Positions are the bottom-centre of this box. */
export const PLAYER_HITBOX = { width: 10, height: 6 } as const;

/** How often the client reports its position while moving. */
export const MOVE_SEND_INTERVAL_MS = 50;

/** Movement budget cap: a player can never cover more than this much time of walking at once. */
export const MAX_MOVE_BUDGET_MS = 500;

/** Allowed rounding and timing slack per move, in pixels. */
export const MOVE_TOLERANCE_PX = 2;

export const MAX_PLAYERS = 6;

/** Number of distinct outfit colours; each player in a room gets their own. */
export const PLAYER_COLOR_COUNT = 6;
